import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import globalReducer, { watcherGlobalSaga } from "./global";
import procedureDetailPageReducer from "./reducers/procedureDetailPageReducer";
import tokenReducer from "./reducers/tokenReducer";

const LogoutType = "LogoutType";
const defaultState = {
  global: {
    test: "",
  },
  auth: {
    accessToken: null,
    refreshToken: null,
  },
};

const appReducer = combineReducers({
  global: globalReducer,
  procedureDetailPage: procedureDetailPageReducer,
  auth: tokenReducer,
});

export const rootReducer = (state: any, action: any) => {
  if (action.type === LogoutType) {
    return defaultState;
  }
  return appReducer(state, action);
};

export function* rootSaga() {
  yield all([watcherGlobalSaga()]);
}
